import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateBillingSellerMutation } from "../graphql/mutations";
import type {
  UpdateBillingSellerMutationType,
  UpdateBillingSellerMutationVariablesType,
} from "@/types/graphql/admin.generated";

export const useUpdateBillingSellerMutation = (
  options?: MutationHookOptions<
    UpdateBillingSellerMutationType,
    UpdateBillingSellerMutationVariablesType
  >
) => {
  return useMutation<
    UpdateBillingSellerMutationType,
    UpdateBillingSellerMutationVariablesType
  >(UpdateBillingSellerMutation, options);
};
